import React, { useEffect } from 'react';
import './App.css';
import './global-text-colors.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Services from './components/Services/Services';
import FactoryAssessment from './components/FactoryAssessment/FactoryAssessment';
import Industries from './components/Industries/Industries';
import Technologies from './components/Technologies/Technologies';
import GlobalPresence from './components/GlobalPresence/GlobalPresence';
import Partners from './components/Partners/Partners';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import VideoBackground from './components/VideoBackground/VideoBackground';

function App() {
  useEffect(() => {
    const contentWrapper = document.querySelector('.content-wrapper');
    const videoOverlay = document.querySelector('.video-overlay');
    
    const handleScroll = () => {
      if (!contentWrapper || !videoOverlay) return;
      
      const scrollTop = contentWrapper.scrollTop;
      const scrollHeight = contentWrapper.scrollHeight - contentWrapper.clientHeight;
      const scrollPercentage = scrollTop / scrollHeight;
      
      // Gradually increase overlay opacity from 0.02 to 0.40 as user scrolls
      const minOpacity = 0.02;
      const maxOpacity = 0.40;
      const overlayOpacity = minOpacity + (scrollPercentage * (maxOpacity - minOpacity));
      
      videoOverlay.style.background = `linear-gradient(
        135deg,
        rgba(10, 10, 30, ${overlayOpacity}) 0%,
        rgba(20, 15, 35, ${overlayOpacity * 0.95}) 50%,
        rgba(15, 10, 25, ${overlayOpacity}) 100%
      )`;
    };
    
    if (contentWrapper) {
      contentWrapper.addEventListener('scroll', handleScroll);
      handleScroll(); // Initial call
      
      return () => contentWrapper.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const whatsappUrl = `https://wa.me/6598522591?text=${encodeURIComponent('Hello Sankavitha, Enquiry from client, please call back')}`;

  return (
    <div className="App">
      <VideoBackground />
      <div className="content-wrapper">
        <Navbar />
        <div className="scroll-container">
          <Hero />
          <About />
          <Services />
          <FactoryAssessment />
          <Industries />
          <Technologies />
          <GlobalPresence />
          <Partners />
          <Contact />
          <Footer />
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="32"
          height="32"
          fill="#fff"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.737 5.469 2.027 7.77L0 32l8.454-2.007A15.938 15.938 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.77-1.853l-.485-.288-5.02 1.193 1.234-4.893-.317-.503A13.269 13.269 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.87c-.398-.199-2.355-1.162-2.72-1.295-.366-.133-.632-.199-.898.199-.265.398-1.029 1.295-1.261 1.56-.232.266-.465.299-.863.1-.398-.2-1.681-.62-3.202-1.977-1.183-1.057-1.982-2.363-2.214-2.761-.232-.398-.025-.613.174-.811.179-.178.398-.465.597-.697.199-.232.265-.398.398-.664.132-.265.066-.498-.033-.697-.1-.199-.898-2.164-1.23-2.962-.324-.778-.654-.673-.898-.685l-.765-.013c-.265 0-.697.1-1.062.498-.365.398-1.394 1.362-1.394 3.32s1.428 3.85 1.627 4.115c.199.265 2.81 4.288 6.81 6.018.952.41 1.695.655 2.274.839.955.304 1.825.261 2.513.158.767-.114 2.355-.962 2.688-1.891.332-.93.332-1.727.232-1.891-.099-.166-.365-.265-.763-.465z"/>
        </svg>
      </a>
    </div>
  );
}

export default App;
